<!-- Header -->
@if (addCategory) {
  <div class="-mx-3">
    <service-category-create
      (changed)="changedEditCategory($event)"
      (close)="addCategory = false"
      [defaultBehaviour]="defaultBehaviour"
      [onlyOne]="onlyClass"
    />
  </div>
}

@if (serviceCreateForm) {
  <form
    [ngClass]="{ hidden: addCategory }"
    [formGroup]="serviceCreateForm"
    (ngSubmit)="saveServiceCreateForm()"
  >
    <div
      class="sticky left-0 top-0 surface-0 z-1 flex align-items-center justify-content-between p-3 border-bottom-1 border-300"
    >
      <h2 class="mb-0 text-sm">
        {{
          activeEditService
            ? ('ADMIN.SUBSCRIPTION.EDIT_SERVICE' | translate)
            : ('ADMIN.SERVICES.ADD_SERVICE' | translate)
        }}
      </h2>
      <i
        (click)="closeDialog()"
        class="fa fa-times text-xl text-600 cursor-pointer"
        aria-label="close-dialog-button"
        data-testid="close-dialog-button"
      ></i>
    </div>
    <!-- Header -->
    @if (planId && planId > 0) {
      <p-message
        severity="info"
        styleClass="relative"
        aria-label="change-message"
      >
        {{ 'ADMIN.SERVICES.CHANGE_MSG' | translate }}
      </p-message>
    }
    <!-- Message -->
    @if (mode === 'addons') {
      <div class="-my-3">
        <p-message
          severity="info"
          styleClass="relative"
          aria-label="change-message"
        >
          <div class="flex align-items-center w-full -my-2 md:m-0">
            <i class="fa fa-info-circle text-xl"></i>
            @if (
              this.subscriptionCategory.key ===
              PlanCategory[PlanCategory.PaidInFull]
            ) {
              <div class="ml-3 text-sm">
                {{ 'ADMIN.SERVICES.NON_RECURRING_MSS' | translate }}
              </div>
            }
            @if (
              this.subscriptionCategory.key !==
              PlanCategory[PlanCategory.PaidInFull]
            ) {
              <div class="ml-3 text-sm">
                {{ 'ADMIN.SERVICES.RECURRING_MSS' | translate }}
              </div>
            }
          </div>
        </p-message>
      </div>
    }
    <!-- Message -->
    <!-- Modal Content -->
    @if (Behavior?.touched && Behavior?.invalid) {
      <app-error-msg
        [errors]="Behavior?.errors"
        [fieldLabel]="'ADMIN.SERVICES.MEMBERSHIP_BEHAVIOUR' | translate"
      />
    }
    <!-- Modal Content -->
    <hr
      class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0"
    />
    @if (mode === 'plans') {
      <div class="p-3 border-bottom-1 border-300 text-sm">
        @if (
          !(
            this.subscriptionCategory.key ===
              PlanCategory[PlanCategory.PaidInFull] ||
            this.subscriptionCategory.key === PlanCategory[PlanCategory.DropIn]
          )
        ) {
          <div
            class="flex align-items-center mb-2"
            data-testid="recurring-services-true-container"
          >
            <p-radioButton
              name="recurring_services"
              [value]="true"
              formControlName="recurring_services"
              aria-label="recurring-services-true-radio"
            />
            <span class="ml-2"
              >{{ 'ADMIN.SERVICES.IS_RECURRING_TRUE' | translate }}
            </span>
          </div>
        }
        <div
          class="flex align-items-center"
          data-testid="recurring-services-false-container"
        >
          <p-radioButton
            name="recurring_services"
            [value]="false"
            formControlName="recurring_services"
            aria-label="recurring-services-false-radio"
          />
          <span class="ml-2">{{
            'ADMIN.SERVICES.IS_RECURRING_FALSE' | translate
          }}</span>
        </div>
      </div>
    }
    <!-- Class Session -->
    <div class="grid m-0 py-2 px-3">
      <!-- Form Group -->
      <div
        class="col-12 md:col-6 md:pr-4"
        data-testid="service-category-container"
      >
        <label class="font-medium text-700 text-xs mb-2 block uppercase">
          {{ 'ADMIN.SERVICES.SERVICE_CATEGORY' | translate }}
          <sup class="p-error">*</sup>
        </label>
        <p-select
          [options]="services"
          placeholder="{{ 'ADMIN.SERVICES.SELECT_SERVICE_CAT' | translate }}"
          optionLabel="name_primary_language"
          filterBy="name_primary_language"
          styleClass="w-full text-sm"
          formControlName="category_id"
          optionDisabled="inactive"
          aria-label="service-category-dropdown"
        >
          <ng-template pTemplate="selectedItem">
            @if (CategoryId) {
              <div class="text-sm">
                {{ CategoryId?.value?.name_primary_language }}
              </div>
            }
          </ng-template>
          <ng-template let-serviceCategory pTemplate="item">
            <div class="text-sm">
              {{ serviceCategory.name_primary_language }}
            </div>
          </ng-template>
          @if (type === 'single') {
            <ng-template pTemplate="footer">
              <div
                (click)="showCategoryDialog()"
                class="text-sm text-primary px-3 py-2 border-top-1 border-300"
                aria-label="add-service-category-button"
                data-testid="add-service-category-button"
              >
                <i class="fa fa-plus mr-2"></i>
                {{ 'ADMIN.SERVICES.ADD_SERVICE_CATEGORY' | translate }}
              </div>
            </ng-template>
          }
        </p-select>
        @if (CategoryId?.touched && CategoryId?.invalid) {
          <app-error-msg
            [errors]="CategoryId?.errors"
            [fieldLabel]="'ADMIN.SERVICES.SERVICE_CATEGORY' | translate"
          />
        }
      </div>
      <!-- Form Group -->
      <!-- Form Group -->
      @if (type === 'single') {
        <div class="col-12 md:col-6 md:pl-4" data-testid="base-cost-container">
          <label class="font-medium text-700 text-xs mb-2 block uppercase"
            >{{ 'ADMIN.SERVICES.BASE_PRICE' | translate }}
            <sup class="p-error">*</sup></label
          >
          <div class="flex align-items-center gap-2">
            <span class="text-sm font-medium">{{ currencySymbol }}</span>
            <!-- <p-inputNumber formControlName="base_cost_in_minor_currency" [format]="false" class="text-sm" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"> </p-inputNumber> -->
            <div class="flex-1">
              <app-shared-input-number
                [formGroup]="serviceCreateForm"
                [controlName]="BaseCostInMinorCurrency"
                [styleClass]="'w-full text-sm'"
                [conditionToFormat]="false"
                aria-label="base-cost-input"
              />
            </div>
          </div>
          @if (
            BaseCostInMinorCurrency?.touched && BaseCostInMinorCurrency?.invalid
          ) {
            <app-error-msg
              [errors]="BaseCostInMinorCurrency?.errors"
              [fieldLabel]="'ADMIN.SERVICES.BASE_PRICE' | translate"
            />
          }
        </div>
      }
      <!-- Form Group -->
      <!-- Form Group -->
      <div
        class="col-12 md:col-6 md:pr-4"
        data-testid="service-name-primary-container"
      >
        <label class="font-medium text-700 text-xs mb-2 block uppercase">
          {{ 'ADMIN.SERVICES.SERVICE_NAME_PRI' | translate }} ({{
            primaryLanguage | translate
          }})
        </label>
        <input
          formControlName="service_name_primary_language"
          type="text"
          pInputText
          placeholder=""
          class="text-sm w-full"
          aria-label="service-name-primary-input"
        />
        @if (
          ServiceNamePriFormControl?.touched &&
          ServiceNamePriFormControl?.invalid
        ) {
          <app-error-msg
            [errors]="ServiceNamePriFormControl?.errors"
            [fieldLabel]="'ADMIN.SERVICES.SERVICE_NAME_PRI' | translate"
          />
        }
      </div>
      <!-- Form Group -->
      <!-- Form Group -->
      @if (isSecondaryLanguage) {
        <div
          class="col-12 md:col-6 md:pl-4"
          data-testid="service-name-secondary-container"
        >
          <label class="font-medium text-700 text-xs mb-2 block uppercase">
            {{ 'ADMIN.SERVICES.SERVICE_NAME_SEC' | translate }} ({{
              secondaryLanguage | translate
            }})
          </label>
          <input
            formControlName="service_name_secondary_language"
            type="text"
            pInputText
            placeholder=""
            class="text-sm w-full"
            aria-label="service-name-secondary-input"
          />
          @if (
            ServiceNameSecFormControl?.touched &&
            ServiceNameSecFormControl?.invalid
          ) {
            <app-error-msg
              [errors]="ServiceNameSecFormControl?.errors"
              [fieldLabel]="'ADMIN.SERVICES.SERVICE_NAME_SEC' | translate"
            />
          }
        </div>
      }
      <!-- Form Group -->
      <!-- Form Group -->
      @if (type === 'single') {
        <div class="col-12 md:col-6 md:pr-4" data-testid="tax-group-container">
          <label class="font-medium text-700 text-xs mb-2 block uppercase">
            {{ 'ADMIN.SERVICES.TAX_GROUP' | translate }}
            <sup class="p-error">*</sup>
          </label>
          <p-select
            [options]="taxGroup"
            placeholder="{{ 'ADMIN.SERVICES.SELECT' | translate }}"
            optionLabel="name_primary_language"
            filterBy="name_primary_language"
            styleClass="w-full text-sm"
            formControlName="taxgrp_id"
            aria-label="tax-group-dropdown"
          >
            <ng-template pTemplate="selectedItem">
              <div class="text-sm">
                {{ TaxGroupId?.value?.name_primary_language }}
              </div>
            </ng-template>
            <ng-template let-taxGroup pTemplate="item">
              <div class="text-sm">{{ taxGroup.name_primary_language }}</div>
            </ng-template>
          </p-select>
          @if (TaxGroupId?.touched && TaxGroupId?.invalid) {
            <app-error-msg
              [errors]="TaxGroupId?.errors"
              [fieldLabel]="'ADMIN.SERVICES.TAX_GROUP' | translate"
            />
          }
        </div>
      }
      <!-- Form Group -->
      <!-- Form Group -->
      @if (type === 'single') {
        <div
          class="col-12 md:col-6 md:pl-4"
          data-testid="tax-item-code-container"
        >
          <label class="font-medium text-700 text-xs mb-2 block uppercase">
            {{ 'ADMIN.SERVICES.TAX_CODE' | translate }}
          </label>
          <input
            formControlName="tax_item_code"
            type="text"
            pInputText
            placeholder=""
            class="text-sm w-full"
            aria-label="tax-item-code-input"
          />
          <!-- <app-error-msg *ngIf=" TaxItemCode?.touched && TaxItemCode?.invalid" [errors]="TaxItemCode?.errors" [fieldLabel]="'ADMIN.SERVICES.TAX_CODE' | translate"></app-error-msg> -->
        </div>
      }
      <!-- Form Group -->
      <!-- Form Group -->
      <div
        class="col-12 md:col-6 md:pr-4"
        data-testid="tax-item-code-container"
      >
        <label class="font-medium text-700 text-xs mb-2 block uppercase">
          {{ 'ADMIN.SERVICES.GL_CODE' | translate }}
        </label>
        <input
          formControlName="gl_code"
          type="text"
          pInputText
          placeholder=""
          class="text-sm w-full"
          aria-label="gl-code-input"
        />
        <!-- <app-error-msg *ngIf=" TaxItemCode?.touched && TaxItemCode?.invalid" [errors]="TaxItemCode?.errors" [fieldLabel]="'ADMIN.SERVICES.TAX_CODE' | translate"></app-error-msg> -->
      </div>
      <!-- Form Group -->
      @if (
        CategoryId?.value?.behaviour ===
          PlanCategoryBehaviour.AppointmentPackage ||
        CategoryId?.value?.behaviour ===
          PlanCategoryBehaviour[PlanCategoryBehaviour.AppointmentPackage] ||
        CategoryId?.value?.behaviour === PlanCategoryBehaviour.ClassPackage ||
        CategoryId?.value?.behaviour ===
          PlanCategoryBehaviour[PlanCategoryBehaviour.ClassPackage]
      ) {
        <div class="col-12 md:col-6 md:pr-4">
          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
            'ADMIN.SERVICES.NUMBER_OF_SESSIONS' | translate
          }}</label>
          <div
            class="flex align-items-center gap-2"
            data-testid="unlimited-sessions-container"
          >
            <div class="p-inputgroup flex-1">
              <span class="p-inputgroup-addon text-sm">
                {{ 'ADMIN.SERVICES.IN_NUMERIC' | translate
                }}<sup class="p-error">*</sup></span
              >
              <!-- <p-inputNumber [format]="false" class="text-sm" mode="decimal" formControlName="sessions"></p-inputNumber> -->
              <app-shared-input-number
                [formGroup]="serviceCreateForm"
                [controlName]="Sessions"
                [styleClass]="'w-full text-sm'"
                [conditionToFormat]="false"
                aria-label="number-of-sessions-input"
              />
            </div>
            <div
              class="flex align-items-center gap-2 surface-50 border-1 border-300 border-round px-3 py-2"
            >
              <span class="text-sm white-space-nowrap">{{
                'ADMIN.SERVICES.UNLIMITED_SESSION' | translate
              }}</span>
              <p-toggleSwitch
                formControlName="is_unlimited_sessions"
                aria-label="unlimited-sessions-switch"
              />
            </div>
          </div>
          @if (Sessions?.touched && Sessions?.invalid) {
            <app-error-msg
              [errors]="Sessions?.errors"
              [fieldLabel]="'ADMIN.SERVICES.NUMBER_OF_SESSIONS' | translate"
            />
          }
        </div>
      }
      <!-- Form Group -->
      <!-- Form Group -->
      @if (!IsRecurringServiceFormControl.value) {
        <div class="col-12 md:col-6 md:pl-4">
          <label class="font-medium text-700 text-xs mb-2 block uppercase"
            >{{ 'ADMIN.SERVICES.SERVICE_DURATION' | translate }}
            <sup class="p-error">*</sup></label
          >
          <div
            class="flex align-items-center gap-2"
            data-testid="interval-type-container"
          >
            <div class="flex-1">
              <p-select
                [options]="planIntervalType"
                formControlName="interval_type"
                styleClass="w-full text-sm"
                [placeholder]="'ADMIN.SUBSCRIPTION.SELECT' | translate"
                aria-label="interval-type-dropdown"
              >
                <ng-template pTemplate="selectedItem">
                  <div class="text-sm">{{ BillingIntervalType?.value }}</div>
                </ng-template>
                <ng-template let-billingInterval pTemplate="item">
                  <div class="text-sm">{{ billingInterval }}</div>
                </ng-template>
              </p-select>
            </div>
            <span class="text-sm font-medium white-space-nowrap">{{
              'ADMIN.SERVICES.ENTER_VALUE' | translate
            }}</span>
            <div class="flex-1" data-testid="billing-interval-value-container">
              <app-shared-input-number
                [formGroup]="serviceCreateForm"
                [controlName]="BillingIntervalValue"
                [styleClass]="'w-full text-sm'"
                [conditionToFormat]="false"
                [mode]="'number'"
                aria-label="billing-interval-value-input"
              />
            </div>
          </div>
          <div class="mt-1">
            @if (BillingIntervalType?.touched && BillingIntervalType?.invalid) {
              <app-error-msg
                [errors]="BillingIntervalType?.errors"
                [fieldLabel]="'ADMIN.SERVICES.SERVICE_DURATION' | translate"
              />
            }
            @if (
              BillingIntervalValue?.touched && BillingIntervalValue?.invalid
            ) {
              <app-error-msg
                [errors]="BillingIntervalValue?.errors"
                [fieldLabel]="'ADMIN.SUBSCRIPTION.VALUE' | translate"
              />
            }
          </div>
        </div>
      }
      <!-- Form Group -->
    </div>
    <!-- Class Session -->
    <hr
      class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0"
    />
    <!-- Message -->
    @if (mode === 'plans') {
      <div class="-mt-3">
        <p-message
          severity="warn"
          styleClass="relative"
          icon="fa-exclamation-triangle"
          aria-label="please-select-message"
        >
          {{ 'ADMIN.SERVICES.PLEASE_SELECT' | translate }}
        </p-message>
      </div>
    }
    <!-- Message -->
    @if (mode === 'plans') {
      <ul class="list-none px-4 m-0">
        <li class="my-3 border-2 border-primary border-round bg-blue-50 p-3">
          <div
            class="flex align-items-start"
            data-testid="member-only-service-container"
          >
            <p-radioButton
              name="is_base_membership_text"
              value="require_base_membership_true"
              formControlName="is_base_membership_text"
              aria-label="member-only-service-radio"
            />
            <div class="ml-2 text-sm">
              <strong class="text-primary font-bold block">
                {{ 'ADMIN.SERVICES.MEMBER_ONLY_SERVICE' | translate }}
                <sup class="p-error">*</sup>
              </strong>
              <span class="block mt-1">
                {{
                  'ADMIN.SERVICES.MEMBER_ONLY_SERVICE_INFO' | translate
                }}</span
              >
            </div>
            <!-- Any Message Should be here -->
          </div>
        </li>
        <li class="my-3 border-2 border-primary border-round bg-blue-50 p-3">
          <div
            class="flex align-items-start"
            data-testid="converts-customer-to-member-container"
          >
            <p-radioButton
              name="is_base_membership_text"
              value="is_base_membership_true"
              formControlName="is_base_membership_text"
              aria-label="converts-customer-to-member-radio"
            />
            <div class="ml-2 text-sm">
              <strong class="text-primary font-bold block">
                {{ 'ADMIN.SERVICES.CONVERTS_CUSTOMER_TO_MEMBER' | translate }}
                <sup class="p-error">*</sup>
              </strong>
              <span class="block mt-1">{{
                'ADMIN.SERVICES.CONVERTS_CUSTOMER_TO_MEMBER_INFO' | translate
              }}</span>
            </div>
          </div>
          <div class="mt-2 mx-4">
            <p-message
              styleClass="relative bg-purple-100 border-left-3 border-purple-700 border-round p-2"
              aria-label="converts-customer-to-member-message"
            >
              <ul class="list-none p-0 m-0 text-sm">
                <li class="py-1">
                  <i class="fa fa-check mr-2"></i>
                  <span
                    >{{ 'ADMIN.SERVICES.STATUS_FROM' | translate }}
                    <strong class="font-bold">{{
                      'ADMIN.SERVICES.PROSPECT_TO_MEMBER' | translate
                    }}</strong></span
                  >
                </li>
                <li class="py-1">
                  <i class="fa fa-check mr-2"></i>
                  <span>
                    {{ 'ADMIN.SERVICES.NOT_ALLOWED' | translate }}
                    <strong class="font-bold">{{
                      'ADMIN.SERVICES.OVERLAPPING' | translate
                    }}</strong>
                    {{ 'ADMIN.SERVICES.SAME_TYPE_SERVICE' | translate }}</span
                  >
                </li>
              </ul>
            </p-message>
          </div>
        </li>
        <li class="my-3 border-2 border-primary border-round bg-blue-50 p-3">
          <div
            class="flex align-items-start"
            data-testid="non-member-service-container"
          >
            <p-radioButton
              name="is_base_membership_text"
              value="is_base_membership_false"
              formControlName="is_base_membership_text"
              aria-label="non-member-service-radio"
            />
            <div class="text-sm ml-2">
              <strong class="text-primary font-bold block">
                {{
                  'ADMIN.SERVICES.NON_MEMBER_SERVICE_FOR_EVERYONE' | translate
                }}
                <sup class="p-error">*</sup>
              </strong>
              <span class="block mt-1">{{
                'ADMIN.SERVICES.NON_MEMBER_SERVICE_FOR_EVERYONE_INFO'
                  | translate
              }}</span>
            </div>
          </div>
          <div class="mt-2 mx-4">
            <p-message
              styleClass="relative bg-purple-100 border-left-3 border-purple-700 border-round p-2"
              aria-label="non-member-service-message"
            >
              <ul class="list-none p-0 m-0 text-sm">
                <li class="py-1">
                  <i class="fa fa-check mr-2"></i>
                  <span>
                    {{ 'ADMIN.SERVICES.CLIENT_STATUS' | translate }}
                    <strong>{{
                      'ADMIN.SERVICES.PROSPECT_TO_NON_MEMBER' | translate
                    }}</strong></span
                  >
                </li>
              </ul>
            </p-message>
          </div>
        </li>
      </ul>
    }
    <div class="grid m-0 py-2 px-3">
      <!-- <div class="col-12">
              <div class="text-sm flex align-items-center line-height-1">
                <span class="mr-3">
                  Members only service
                  <sup class="p-error">*</sup></span>
                  <p-toggleSwitch formControlName="require_base_membership"></p-toggleSwitch>
                </div>
              </div> -->
      <!-- <div class="col-12 md:col-4 md:pr-4 flex align-items-center">
              <p-radioButton name="is_base_membership_text" value="require_base_membership_true"
              formControlName="is_base_membership_text"></p-radioButton>
              <span class="text-sm ml-2">
                {{'ADMIN.SERVICES.MEMBER_ONLY_SERVICE' | translate}}
                <sup class="p-error">*</sup>
              </span>
            </div>
            <div class="col-12 md:col-4 md:pr-4 flex align-items-center">
              <p-radioButton name="is_base_membership_text" value="is_base_membership_true"
              formControlName="is_base_membership_text"></p-radioButton>
              <span class="text-sm ml-2">
                {{'ADMIN.SERVICES.CONVERTS_CUSTOMER_TO_MEMBER' | translate}}
                <sup class="p-error">*</sup>
              </span>
            </div>
            <div class="col-12 md:col-4 md:pl-4 flex align-items-center">
              <p-radioButton name="is_base_membership_text" value="is_base_membership_false"
              formControlName="is_base_membership_text"></p-radioButton>
              <span class="text-sm ml-2">
                {{'ADMIN.SERVICES.NON_MEMBER_SERVICE_FOR_EVERYONE' | translate}}
                <sup class="p-error">*</sup></span>
              </div> -->
      @if (IsBaseMembership?.touched && IsBaseMembership?.invalid) {
        <app-error-msg
          [errors]="IsBaseMembership?.errors"
          [fieldLabel]="
            'ADMIN.SERVICES.BASE_MEMBERSHIP_CONVERSION_TYPE' | translate
          "
        />
      }
    </div>
    <!-- Modal Footer -->
    <div
      class="sticky left-0 bottom-0 surface-0 z-1 p-3 flex align-items-center justify-content-between border-top-1 border-300 surface-0"
    >
      <div class="w-4" data-testid="cancel-button-container">
        <p-button
          type="button"
          label="{{ 'ADMIN.COMMON.CANCEL' | translate }}"
          (click)="closeDialog()"
          styleClass="p-button-link text-sm"
          aria-label="cancel-button"
        />
      </div>
      <div class="w-8 text-right" data-testid="submit-service-button-container">
        <button
          class="text-sm"
          type="submit"
          pButton
          pRipple
          label="{{
            activeEditService
              ? ('ADMIN.SERVICES.UPDATE_SERVICE' | translate)
              : ('ADMIN.SERVICES.ADD_SERVICE' | translate)
          }}"
          aria-label="submit-service-button"
        ></button>
      </div>
    </div>
    <!-- Modal Footer -->
  </form>
}
